import React from 'react'

const DEVICE_SVG_WIDTH = 215

export const SoftwareUpdateAnimation = ({ progressPercentage, anomaly }) => {
  const progressWidth =
    DEVICE_SVG_WIDTH * ((anomaly ? 100 : progressPercentage) / 100)
  const fillColor = anomaly ? '#E6410D' : '#00EB96'

  return (
    <svg
      width="798"
      height="523"
      viewBox="0 0 798 523"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M527.122 305.347C543.814 305.347 562.237 310.295 606.173 290.408C699.5 248.168 829.944 219.756 867.5 247.5"
          stroke="#E6E1D2"
          strokeWidth="6.54"
        />
        <path
          d="M527 278.5C539.913 278.5 570.353 279.867 610.5 276.785C688.409 270.804 821.929 245.185 861.5 279.602"
          stroke="#E6E1D2"
          strokeWidth="6.54"
        />
        <path
          d="M527 337.091C639 337.091 711 390 842 336.225"
          stroke="#00EB96"
          strokeWidth="5.36"
        />
        <path
          d="M294.949 336.643C196.501 336.643 62.2051 384.276 -9.99902 299"
          stroke="#E6E1D2"
          strokeWidth="5"
        />
        <path
          d="M307 307.245C276.715 308.834 231.144 302.361 221.967 313.486C212.789 324.611 215.268 330.173 221.967 328.584C227.315 327.315 222.884 310.307 213.707 311.102C204.53 311.897 196.242 330.173 206.067 330.173C215.892 330.173 207.283 311.102 198.105 311.102C188.928 311.102 178.464 332.557 193.186 330.173C202.675 328.637 193.186 311.102 183.422 311.102C170.182 311.102 163.742 331.862 178.464 330.173C186.745 329.224 178.833 311.102 168.738 311.102C155.628 311.102 149.941 331.498 161.902 330.173C172.023 329.052 162.541 309.294 153.136 311.102C140.737 313.486 134.299 334.643 147.63 332.557C156.517 331.167 147.63 311.82 138.452 313.486C125.317 315.87 124.178 335.285 133.379 334.147C142.58 333.009 132.028 313.486 121.933 315.87C110.264 318.625 106.696 339.51 120.098 335.736C128.084 333.487 114.591 315.075 103.578 318.254C92.5655 321.432 96.2365 340.504 103.578 338.12C110.92 335.736 98.9897 319.843 89.8123 323.022C80.635 326.2 80.0129 345.203 86.4536 343.682C96.5487 341.298 81.5527 324.611 68.7043 328.584C55.856 332.557 59.7706 349.589 65.0334 348.45C72.3753 346.861 63.1979 330.173 48.5141 334.147C33.8303 338.12 40.2545 357.191 48.5141 354.807C56.7738 352.423 37.6645 336.034 28.4871 341.596C19.3097 347.159 23.7352 365.932 31.0771 361.959C38.419 357.986 24.6529 344.378 14.5578 349.94C4.46271 355.503 6.29818 373.084 14.5578 369.111C22.8175 365.138 8.13366 354.013 -0.125981 357.986C-6.73369 361.165 -26.1285 383.15 -35 393.745"
          stroke="#E6E1D2"
          strokeWidth="3.18"
        />
        <path
          d="M276.895 252.439C141.999 256.164 88.499 221.5 -21.001 281"
          stroke="#E6E1D2"
          strokeWidth="9"
        />
        <path
          d="M516.5 246.5C669.222 246.5 707.471 156.853 861.107 197.445"
          stroke="#E6E1D2"
          strokeWidth="3.87428"
        />
        <path
          d="M273.001 214C238.79 214.087 201.984 205.113 182 200C76.2206 172.936 40.7162 205.835 -24.499 206"
          stroke="#E6E1D2"
          strokeWidth="9"
        />
        <rect
          x="313.951"
          y="262.103"
          width="56.6758"
          height="19.3289"
          rx="1.47383"
          transform="rotate(-180 313.951 262.103)"
          fill="#E6E1D2"
          stroke="#E6E1D2"
          strokeWidth="0.589532"
        />
        <path
          d="M313.951 225.585C313.951 227.136 312.626 228.356 311.081 228.229L259.711 223.997C258.335 223.884 257.276 222.734 257.276 221.353L257.276 205.592C257.276 204.197 258.355 203.04 259.747 202.945L311.117 199.418C312.65 199.313 313.951 200.528 313.951 202.065L313.951 225.585Z"
          fill="#E6E1D2"
          stroke="#E6E1D2"
          strokeWidth="0.589532"
        />
        <path
          d="M268.239 223.119C268.192 223.634 267.716 223.999 267.207 223.911L231.403 217.718C230.95 217.639 230.632 217.226 230.673 216.767L231.75 204.752C231.792 204.289 232.185 203.937 232.65 203.947L268.94 204.711C269.452 204.722 269.848 205.164 269.802 205.674L268.239 223.119Z"
          fill="#E6E1D2"
          stroke="#E6E1D2"
          strokeWidth="0.589532"
        />
        <rect
          x="313.951"
          y="311.42"
          width="25.5533"
          height="8.12476"
          rx="0.294766"
          transform="rotate(-180 313.951 311.42)"
          fill="#E6E1D2"
          stroke="#E6E1D2"
          strokeWidth="0.589532"
        />
        <rect
          x="313.951"
          y="341.328"
          width="29.288"
          height="9.36966"
          rx="0.294766"
          transform="rotate(-180 313.951 341.328)"
          fill="#E6E1D2"
          stroke="#E6E1D2"
          strokeWidth="0.589532"
        />
        <path
          d="M513.43 314.178C513.43 315.116 514.239 315.851 515.174 315.76L553.075 312.085C553.89 312.006 554.512 311.321 554.512 310.502L554.512 300.669C554.512 299.839 553.873 299.148 553.045 299.084L515.143 296.144C514.219 296.072 513.43 296.802 513.43 297.729L513.43 314.178Z"
          fill="#E6E1D2"
          stroke="#E6E1D2"
          strokeWidth="0.589532"
        />
        <path
          d="M513.43 287.167C513.43 288.106 514.239 288.84 515.174 288.749L553.075 285.074C553.89 284.995 554.512 284.31 554.512 283.492L554.512 273.658C554.512 272.828 553.873 272.137 553.045 272.073L515.143 269.133C514.219 269.061 513.43 269.792 513.43 270.718L513.43 287.167Z"
          fill="#E6E1D2"
          stroke="#E6E1D2"
          strokeWidth="0.589532"
        />
        <path
          d="M540.818 337.335C540.818 338.104 540.513 338.842 539.969 339.386L535.64 343.714C534.856 344.498 533.793 344.938 532.685 344.938L520.1 344.938C517.792 344.938 515.92 343.067 515.92 340.758L515.92 334.18C515.92 331.871 517.792 330 520.1 330L532.745 330C533.818 330 534.849 330.412 535.626 331.151L539.917 335.233C540.493 335.781 540.818 336.54 540.818 337.335Z"
          fill="#00EB96"
          stroke="#00EB96"
          strokeWidth="0.589532"
        />
        <rect
          x="538.033"
          y="251.961"
          width="24.3084"
          height="11.8595"
          rx="0.294766"
          transform="rotate(-180 538.033 251.961)"
          fill="#E6E1D2"
          stroke="#E6E1D2"
          strokeWidth="0.589532"
        />
        <mask id="path-22-inside-1" fill="white">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M543.42 209.541L547.882 209.541L547.882 199.725L550.11 199.725L550.11 207.087L554.572 207.087L554.572 199.725L556.806 199.725L556.806 204.633L561.268 204.633L561.268 199.725L561.268 194.817L561.268 189.909L556.806 189.909L556.806 194.817L554.572 194.817L554.572 187.454L550.11 187.454L550.11 194.817L547.882 194.817L547.882 185L543.42 185L543.42 194.817L541.186 194.817L541.186 185L512.183 185L512.183 209.541L541.186 209.541L541.186 199.725L543.42 199.725L543.42 209.541Z"
          />
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M543.42 209.541L547.882 209.541L547.882 199.725L550.11 199.725L550.11 207.087L554.572 207.087L554.572 199.725L556.806 199.725L556.806 204.633L561.268 204.633L561.268 199.725L561.268 194.817L561.268 189.909L556.806 189.909L556.806 194.817L554.572 194.817L554.572 187.454L550.11 187.454L550.11 194.817L547.882 194.817L547.882 185L543.42 185L543.42 194.817L541.186 194.817L541.186 185L512.183 185L512.183 209.541L541.186 209.541L541.186 199.725L543.42 199.725L543.42 209.541Z"
          fill="#00EB96"
        />
        <path
          d="M547.882 209.541L547.882 210.131L548.471 210.131L548.471 209.541L547.882 209.541ZM543.42 209.541L542.83 209.541L542.83 210.131L543.42 210.131L543.42 209.541ZM547.882 199.725L547.882 199.136L547.292 199.136L547.292 199.725L547.882 199.725ZM550.11 199.725L550.699 199.725L550.699 199.136L550.11 199.136L550.11 199.725ZM550.11 207.087L549.52 207.087L549.52 207.676L550.11 207.676L550.11 207.087ZM554.572 207.087L554.572 207.676L555.161 207.676L555.161 207.087L554.572 207.087ZM554.572 199.725L554.572 199.136L553.982 199.136L553.982 199.725L554.572 199.725ZM556.806 199.725L557.395 199.725L557.395 199.136L556.806 199.136L556.806 199.725ZM556.806 204.633L556.216 204.633L556.216 205.223L556.806 205.223L556.806 204.633ZM561.268 204.633L561.268 205.223L561.857 205.223L561.857 204.633L561.268 204.633ZM561.268 199.725L560.678 199.725L561.268 199.725ZM561.268 194.817L561.857 194.817L561.268 194.817ZM561.268 189.909L561.857 189.909L561.857 189.319L561.268 189.319L561.268 189.909ZM556.806 189.909L556.806 189.319L556.216 189.319L556.216 189.909L556.806 189.909ZM556.806 194.817L556.806 195.406L557.395 195.406L557.395 194.817L556.806 194.817ZM554.572 194.817L553.982 194.817L553.982 195.406L554.572 195.406L554.572 194.817ZM554.572 187.454L555.161 187.454L555.161 186.865L554.572 186.865L554.572 187.454ZM550.11 187.454L550.11 186.865L549.52 186.865L549.52 187.454L550.11 187.454ZM550.11 194.817L550.11 195.406L550.699 195.406L550.699 194.817L550.11 194.817ZM547.882 194.817L547.292 194.817L547.292 195.406L547.882 195.406L547.882 194.817ZM547.882 185L548.471 185L548.471 184.411L547.882 184.411L547.882 185ZM543.42 185L543.42 184.411L542.83 184.411L542.83 185L543.42 185ZM543.42 194.817L543.42 195.406L544.009 195.406L544.009 194.817L543.42 194.817ZM541.186 194.817L540.596 194.817L540.596 195.406L541.186 195.406L541.186 194.817ZM541.186 185L541.775 185L541.775 184.411L541.186 184.411L541.186 185ZM512.183 185L512.183 184.411L511.593 184.411L511.593 185L512.183 185ZM512.183 209.541L511.593 209.541L511.593 210.131L512.183 210.131L512.183 209.541ZM541.186 209.541L541.186 210.131L541.775 210.131L541.775 209.541L541.186 209.541ZM541.186 199.725L541.186 199.136L540.596 199.136L540.596 199.725L541.186 199.725ZM543.42 199.725L544.009 199.725L544.009 199.136L543.42 199.136L543.42 199.725ZM547.882 208.951L543.42 208.951L543.42 210.131L547.882 210.131L547.882 208.951ZM547.292 199.725L547.292 209.541L548.471 209.541L548.471 199.725L547.292 199.725ZM550.11 199.136L547.882 199.136L547.882 200.315L550.11 200.315L550.11 199.136ZM549.52 199.725L549.52 207.087L550.699 207.087L550.699 199.725L549.52 199.725ZM550.11 207.676L554.572 207.676L554.572 206.497L550.11 206.497L550.11 207.676ZM555.161 207.087L555.161 199.725L553.982 199.725L553.982 207.087L555.161 207.087ZM556.806 199.136L554.572 199.136L554.572 200.315L556.806 200.315L556.806 199.136ZM556.216 199.725L556.216 204.633L557.395 204.633L557.395 199.725L556.216 199.725ZM556.806 205.223L561.268 205.223L561.268 204.044L556.806 204.044L556.806 205.223ZM561.857 204.633L561.857 199.725L560.678 199.725L560.678 204.633L561.857 204.633ZM560.678 194.817L560.678 199.725L561.857 199.725L561.857 194.817L560.678 194.817ZM561.857 194.817L561.857 189.909L560.678 189.909L560.678 194.817L561.857 194.817ZM561.268 189.319L556.806 189.319L556.806 190.498L561.268 190.498L561.268 189.319ZM556.216 189.909L556.216 194.817L557.395 194.817L557.395 189.909L556.216 189.909ZM554.572 195.406L556.806 195.406L556.806 194.227L554.572 194.227L554.572 195.406ZM555.161 194.817L555.161 187.454L553.982 187.454L553.982 194.817L555.161 194.817ZM554.572 186.865L550.11 186.865L550.11 188.044L554.572 188.044L554.572 186.865ZM549.52 187.454L549.52 194.817L550.699 194.817L550.699 187.454L549.52 187.454ZM547.882 195.406L550.11 195.406L550.11 194.227L547.882 194.227L547.882 195.406ZM547.292 185L547.292 194.817L548.471 194.817L548.471 185L547.292 185ZM543.42 185.59L547.882 185.59L547.882 184.411L543.42 184.411L543.42 185.59ZM544.009 194.817L544.009 185L542.83 185L542.83 194.817L544.009 194.817ZM541.186 195.406L543.42 195.406L543.42 194.227L541.186 194.227L541.186 195.406ZM541.775 194.817L541.775 185L540.596 185L540.596 194.817L541.775 194.817ZM541.186 184.411L512.183 184.411L512.183 185.59L541.186 185.59L541.186 184.411ZM511.593 185L511.593 209.541L512.772 209.541L512.772 185L511.593 185ZM512.183 210.131L541.186 210.131L541.186 208.951L512.183 208.951L512.183 210.131ZM541.775 209.541L541.775 199.725L540.596 199.725L540.596 209.541L541.775 209.541ZM543.42 199.136L541.186 199.136L541.186 200.315L543.42 200.315L543.42 199.136ZM544.009 209.541L544.009 199.725L542.83 199.725L542.83 209.541L544.009 209.541Z"
          fill="#00EB96"
          mask="url(#path-22-inside-1)"
        />
        <path
          d="M538.5 197.5C598.5 197.5 629.704 197.728 681 225.5C759.5 268 777.5 343 914 291.5"
          stroke="#00EB96"
          strokeWidth="7.95"
        />
        <rect x="305" y="155" width="215" height="215" rx="28" fill="#E6E1D2" />
        <rect
          x="305"
          y="155"
          width={progressWidth}
          height="215"
          fill={fillColor}
          clipPath="url(#device)"
        />
        <rect x="350" y="267" width="170" height="60" fill="#1C1C1C" />
        <path
          d="M355.586 273.619L386.885 273.62L386.885 282.426L365.381 282.425L365.381 286.115L355.586 286.115L355.586 273.619Z"
          fill="white"
        />
        <path
          d="M389.643 273.62L399.275 273.62L399.274 319.899L389.643 319.899L389.643 273.62Z"
          fill="white"
        />
        <path
          d="M365.381 287.609L355.586 287.608L355.586 305.426L365.38 305.426L365.38 301.53L386.894 301.531L386.894 291.978L365.381 291.977L365.381 287.609Z"
          fill="white"
        />
        <path
          d="M355.586 306.902L365.38 306.903L365.38 311.082L386.894 311.083L386.894 319.899L355.586 319.899L355.586 306.902Z"
          fill="white"
        />
        <path
          d="M411.758 319.898L411.758 308.87L414.361 305.909L423.838 319.899L435.119 319.899L421.57 300.219L434.466 285.191L423.408 285.191L412.282 298.365L411.758 298.365L411.758 273.621L402.127 273.62L402.127 319.898L411.758 319.898Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="798" height="523" fill="white" />
        </clipPath>
        <clipPath id="device">
          <rect x="305" y="155" width="215" height="215" rx="28" />
        </clipPath>
      </defs>
    </svg>
  )
}
